import React from 'react';
import SupportRequestsRealDataTable from '@/components/tables/SupportRequestsRealDataTable';
import { useAuth } from '@/contexts/AuthContext';

interface SupportRequestsPageProps {
    onNavigate: (view: string) => void;
}

const SupportRequestsPage: React.FC<SupportRequestsPageProps> = ({ onNavigate }) => {
    const { currentUser } = useAuth();

    return (
        <div className="space-y-8 animate-in fade-in">
          <div className="flex justify-between items-center">
            <h1 className="text-3xl font-bold text-white mb-1">Support Requests Management</h1>
            <button
              onClick={() => onNavigate('/dashboard')}
              className="bg-kala-secondary hover:bg-cyan-400 text-kala-900 font-bold py-2 px-4 rounded"
            >
              Back to Dashboard
            </button>
          </div>
          <div id="support-requests-table" className="mt-8">
            {currentUser ? (
              <SupportRequestsRealDataTable currentUserRole={currentUser.role} currentUserId={currentUser.id} />
            ) : (
              <p>Loading user information...</p>
            )}
          </div>
        </div>
      );
};

export default SupportRequestsPage;
